import { singleCoordinates, zoomLevelDefault } from "helpers/constants";
import { AppAction, AppContext } from "helpers/context";
import { MapContext } from "helpers/map";
import { CSSProperties, useContext } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as DistanceIconSvg } from "assets/icon_world_zoom.svg";
import styles from "./world-zoom.module.scss";
import { Tooltip } from "@mui/material"

interface WorldZoomProps {
	map?: any;
	className?: string;
	style?: CSSProperties;
}

function WorldZoom({ map: mapFromProps, className, style }: WorldZoomProps) {
	const [context, dispatch] = useContext(AppContext);
	const { map: mapFromContext } = useContext(MapContext);
	const map = mapFromProps || mapFromContext;

	const [t] = useTranslation();

	const resetZoom = () => {
		if (!map) return;
		dispatch({ type: AppAction.setMapZoom, payload: zoomLevelDefault });
		dispatch({ type: AppAction.setMapCenter, payload: singleCoordinates });

		map.setZoomAndCenter(zoomLevelDefault, zoomLevelDefault);
	};

	return (
		<div
			className={`${styles.zoom} ${className || ""}`}
			style={style}
			onClick={resetZoom}
		>
			<Tooltip
				title={t(`map.tip`)}
			>
				<DistanceIconSvg className={styles.icon} />
			</Tooltip>
		</div>
	);
}

export default WorldZoom;
